import React from 'react';

export const ArrowUp: React.FC = () => {
  return (
    <svg
      width="15"
      height="8"
      viewBox="0 0 15 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.749 7L7.49359 0.75L1.23816 7"
        stroke="#333F48"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
